/**
 * Key constants for the `cc`-type payment methods (Credit Card, Google Pay,
 * Apple Pay) and the digital-wallet key check.
 *
 * Payment method titles are not decided here: Panoramic 2.0 shows the `title`
 * the backend sends for every method, including these three. The file keeps
 * its historical name because many modules import the key constants from it.
 */
export const CREDIT_CARD_KEY = 'Credit Card';
export const GOOGLE_PAY_CC_KEY = 'google_pay_cc';
export const APPLE_PAY_CC_KEY = 'apple_pay_cc';

export const isDigitalWalletCcKey = (paymentMethodKey?: string | null): boolean =>
  paymentMethodKey === GOOGLE_PAY_CC_KEY || paymentMethodKey === APPLE_PAY_CC_KEY;
